<div class="guidelines-container">
  <h1>Community Guidelines Policy</h1>
  <p class="last-updated">Last Updated: 26/07/2025</p>

  <section>
    <h2>Introduction</h2>
    <p>Upstanding Citizen ("we", "us", "our", "Company") strives to create a safe, respectful, and welcoming online community for all users. These Community Guidelines outline the expected behavior when using our platform, including the posting, sharing, and interaction with other users. By using our platform, you agree to comply with these guidelines and ensure that your conduct adheres to South African laws and regulations.<br>
    Failure to comply with these guidelines may result in actions such as warnings, temporary suspensions, or permanent bans, depending on the severity of the violation.</p>
  </section>

  <section>
    <h2>Respect and Courtesy</h2>
    <ul>
      <li>Harassment or Bullying: Abusive, threatening, or demeaning language directed at individuals or groups.</li>
      <li>Hate Speech: Any content that promotes hatred, violence, or discrimination based on race, ethnicity, religion, gender, sexual orientation, or disability.</li>
      <li>Personal Attacks: Attacking individuals, groups, or communities on the basis of their personal beliefs, backgrounds, or identity.</li>
    </ul>
  </section>

  <section>
    <h2>Prohibited Content</h2>
    <ul>
      <li>Child Exploitation and Pornography: Any content involving or promoting child pornography or any form of exploitation of minors, in compliance with the Sexual Offences Act (Act 32 of 2007), the Films and Publications Act, and the Criminal Law (Sexual Offences and Related Matters) Amendment Act.</li>
      <li>Illegal Content or Activities: Content that promotes or facilitates criminal activities such as fraud, theft, cybercrime, terrorism, or drug trafficking.</li>
      <li>Intellectual Property Infringement: Users are not permitted to post content that infringes upon the intellectual property rights of others, including copyrighted materials, trademarks, or patents.</li>
      <li>Spam and Scams: Posting misleading, deceptive, or harmful content, including phishing links, fraudulent investment opportunities, and unsolicited advertisements.</li>
    </ul>
  </section>

  <section>
    <h2>Privacy and Data Protection</h2>
    <ul>
      <li>Personal Information: Do not share or post personal information of others without their explicit consent, including addresses, phone numbers, email addresses, or any sensitive personal data.</li>
      <li>Data Breaches: Users must refrain from attempting to access, disclose, or steal data belonging to other users or the platform.</li>
      <li>Respect for Intellectual Property: Do not upload or distribute content that violates the intellectual property rights of others.</li>
    </ul>
  </section>

  <section>
    <h2>Safety and Security</h2>
    <ul>
      <li>Account Security: Users are responsible for keeping their account credentials secure and must report any suspicious activities or unauthorized access immediately.</li>
      <li>Impersonation and Fake Profiles: Users must not impersonate others or create fake profiles with the intent to deceive or mislead.</li>
      <li>Malicious Software: Users should refrain from uploading, sharing, or distributing viruses, worms, Trojan horses, or any other malware that could damage or disrupt the platform’s functionality or other users' devices.</li>
    </ul>
  </section>

  <section>
    <h2>Compliance with South African Law</h2>
    <ul>
      <li>The Constitution of South Africa (Act 108 of 1996): Users are expected to respect and adhere to the rights and freedoms guaranteed in the Constitution, including the right to dignity, equality, and freedom of expression.</li>
      <li>The Films and Publications Act (Act 65 of 1996): All content shared must adhere to the classifications and regulations outlined in the Films and Publications Act, which prohibits the distribution of obscene, harmful, or disturbing content.</li>
      <li>The Cybercrimes and Cybersecurity Act (Act 19 of 2020): The Act criminalizes cybercrimes such as hacking, phishing, identity theft, and the distribution of malware. Any content or behavior that encourages or facilitates such activities will be reported to law enforcement authorities.</li>
    </ul>
  </section>

  <section>
    <h2>Reporting Violations</h2>
    <ul>
      <li>Investigation: We will investigate reported content or behavior promptly.</li>
      <li>Action: Depending on the severity of the violation, we may issue a warning, suspend the user’s account, or permanently ban the user from the platform.</li>
      <li>Notification: If necessary, we will notify relevant law enforcement agencies, including the South African Police Service (SAPS) or the Cybersecurity Hub, in the case of illegal activity or cybercrime.</li>
    </ul>
  </section>

  <section>
    <h2>Enforcement and Consequences</h2>
    <ul>
      <li>Warning: Users may receive a formal warning regarding their behavior.</li>
      <li>Account Suspension: Users may face a temporary suspension from the platform while an investigation is conducted.</li>
      <li>Permanent Ban: Users who repeatedly violate these guidelines or engage in illegal activity may be permanently banned from the platform.</li>
      <li>Legal Action: In cases of severe violations, including cybercrime or the distribution of illegal content, we may refer the matter to law enforcement for further action.</li>
    </ul>
  </section>

  <section>
    <h2>User Responsibility</h2>
    <ul>
      <li>Abide by these Community Guidelines and all applicable laws.</li>
      <li>Respect the rights of other users and the platform.</li>
      <li>Report any content or behaviour that violates these guidelines.</li>
    </ul>
  </section>

  <section>
    <h2>Amendments to the Guidelines</h2>
    <p>We reserve the right to update or modify these Community Guidelines at any time. Any changes will be posted on this page, and the "Last Updated" date will be revised accordingly. We recommend reviewing this page periodically to stay informed about the guidelines.</p>
  </section>

  <section>
    <h2>Contact Information</h2>
    <p>[Company Name]<br>[Company Address]<br>[Email Address]<br>[Phone Number]</p>
  </section>

  <section>
    <h2>Legal Disclaimer</h2>
    <p>By participating on our platform, users agree to comply with these Community Guidelines. Violations of these guidelines may result in account suspension or termination, and in cases of illegal activity, law enforcement will be notified in accordance with South African law.<br>
    In line with South African law, specifically the Constitution, the Promotion of Equality and Prevention of Unfair Discrimination Act (Act No. 4 of 2000), and the Films and Publications Act (Act 65 of 1996), we maintain a zero-tolerance policy towards discrimination and hate speech.<br>
    In compliance with the Protection of Personal Information Act (POPIA), users are required to respect the privacy of others and ensure that no personal data is unlawfully collected, stored, or disclosed.<br>
    In accordance with the Cybercrimes and Cybersecurity Act (2020), any act of cybercrime, including unauthorized access to user accounts, unauthorized data collection, or distributing malicious content, will result in severe penalties and legal action.</p>
  </section>
</div>
